export class MoneyUtil {
  static dollarsToCent(dollars: string): number {
    let cents: any = 0;
    // Remove the spaces
    cents = parseFloat(dollars.replace(/\s/g, ''));

    // Multiply by 100
    cents = Math.round(cents * 100);

    return cents;
  }

  static centsToDollars(cents: number): number {
    return MoneyUtil.roundToCent(cents) / 100;
  }

  static roundToCent(cents: number): number {
    return Math.round(cents);
  }

  /**
   * At the time of writing this comment, the forms in the frontend are working with dollars amount. Therefore, this
   * method only return in dollars. If you expect a default value to be used by the server, you cannot use this since
   * the server expects to receive a value in cents.
   * @param dollars
   */
  static dollarsForDefaultValueInTheFrontend(dollars: string): number {
    const normalizedDollars = parseFloat(dollars.replace(/\s/g, ''));

    return normalizedDollars;
  }
}